import { createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { EventRegistrationModel } from "@tCooneyBrothers/ApiModels";
import { addEventRegistrationFields as addEventRegistrationApi } from "@tCooneyBrothers/Services/EventRegistrationService";
import { CustomApiHandler } from "@tCooneyBrothers/Store/CustomHandlerCreator";

type EventRegistrationParam = {
    addEventRegistrationParams: EventRegistrationModel;
} & HasOnSuccess;

type HandlerType = CustomApiHandler<EventRegistrationParam, EventRegistrationModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await addEventRegistrationApi(props.parameter.addEventRegistrationParams);
};

export const DispatchEventRegistrationFields: HandlerType = props => {
    props.dispatch({
        type: "Data/EventRegistrationFields/fields",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};
export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchEventRegistrationFields,
    ExecuteOnSuccessCallback,
];

const addEventRegistrationFormFields = createHandlerChainRunner(chain, "addEventRegistrationFields");
export default addEventRegistrationFormFields;
